"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = CompanyEmployees;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const react_native_2 = require("react-native");
const async_storage_1 = __importDefault(require("@react-native-async-storage/async-storage"));
const react_native_paper_1 = require("react-native-paper");
const cancelable_promise_1 = require("cancelable-promise");
const react_native_device_info_1 = __importDefault(require("react-native-device-info"));
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const react_native_gesture_handler_1 = require("react-native-gesture-handler");
const Theme_1 = require("../Theme");
const ThemeContext_1 = require("../ThemeContext");
const Button_1 = __importDefault(require("../components/Button"));
const PlatformModal_1 = __importDefault(require("../components/PlatformModal"));
const UserContext_1 = require("../contexts/UserContext");
const AdminContext_1 = require("../contexts/AdminContext");
const Employees_1 = __importDefault(require("../api/Employees"));
const ElevatePermissions_1 = __importDefault(require("../ElevatePermissions"));
const ResponsiveContext_1 = require("../contexts/ResponsiveContext");
const react_i18next_1 = require("react-i18next");
const Columns = {
    'id': {
        label: 'Employee ID',
        group: 1,
        filterable: false,
    },
    'fullName': {
        label: 'Full Name',
        group: 1,
        filterable: false,
        addFirstColumn: true,
    },
    'lastName': {
        label: 'Last Name',
        group: 1,
        filterable: false,
        addFirstColumn: true,
    },
    'firstName': {
        label: 'First Name',
        group: 1,
        filterable: false,
        addFirstColumn: true,
    },
    'statusClass': {
        label: 'Status',
        group: 1,
        filterable: true,
        filterValues: ['Active', 'On Leave', 'Terminated', 'New Hire'],
        value: (e) => {
            switch (e.statusClass) {
                case 'A': return 'Active';
                case 'L': return 'On Leave';
                case 'T': return 'Terminated';
                case 'P': return 'New Hire';
                default: return e.statusClass;
            }
        },
    },
    'hireDate': {
        label: 'Hire Date',
        group: 1,
        filterable: false,
        sortValue: (e) => {
            if (e.hireDate) {
                let split = e.hireDate.split('/');
                if (split.length == 3 && split[2].length == 4) {
                    return `${split[2]}${split[0]}${split[1]}`;
                }
            }
            return '';
        },
    },
    'employeeTypeText': {
        label: 'Employee Type',
        group: 1,
        filterable: true,
    },
    'manager': {
        label: 'Manager',
        group: 3,
        filterable: true,
    },
    'ptoApprover': {
        label: 'PTO Approver',
        group: 3,
        filterable: true,
    },
    'jobTitle': {
        label: 'Job Title',
        group: 1,
        filterable: true,
    },
    'location': {
        label: 'Location Code',
        group: 2,
        filterable: true,
    },
    'locationText': {
        label: 'Location',
        group: 2,
        filterable: true,
    },
    'division': {
        label: 'Division Code',
        group: 2,
        filterable: true,
    },
    'divisionText': {
        label: 'Division',
        group: 2,
        filterable: true,
    },
    'department': {
        label: 'Department Code',
        group: 2,
        filterable: true,
    },
    'departmentText': {
        label: 'Department',
        group: 2,
        filterable: true,
    },
    'workEmail': {
        label: 'Work Email',
        group: 1,
        filterable: false,
    },
    'workPhone': {
        label: 'Work Phone',
        group: 1,
        filterable: false,
    },
};
const SortedColumnKeys = Object.keys(Columns).sort((a, b) => {
    return Columns[a]?.label?.localeCompare(Columns[b]?.label ?? '') ?? 0;
});
const SortedColumnKeysGrouped = Object.keys(Columns).sort((a, b) => {
    return (Columns[a]?.group - Columns[b]?.group)
        || (Columns[a]?.label?.localeCompare(Columns[b]?.label ?? '') ?? 0);
}).reduce((all, c) => {
    let group = Columns[c]?.group ?? 0;
    if (!(group in all))
        all[group] = [];
    all[group].push(c);
    return all;
}, {});
const EmployeeTableWeb = (props) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const THEME = (0, ThemeContext_1.useTheme)();
    const [columns, setColumns] = react_1.default.useState(props.columns);
    const [dragging, setDragging] = react_1.default.useState({});
    react_1.default.useEffect(() => {
        setColumns(props.columns);
    }, [props.columns]);
    const fieldRenderWeb = {
        'fullName': (e, k, t, s) => ((0, jsx_runtime_1.jsx)("td", { style: { ...s }, children: (0, jsx_runtime_1.jsx)("span", { style: { color: t.Text, fontWeight: '500' }, children: e.fullName }) }, k)),
        'firstName': (e, k, t, s) => ((0, jsx_runtime_1.jsx)("td", { style: { ...s }, children: (0, jsx_runtime_1.jsx)("span", { style: { color: t.Text, fontWeight: '500' }, children: e.firstName }) }, k)),
        'lastName': (e, k, t, s) => ((0, jsx_runtime_1.jsx)("td", { style: { ...s }, children: (0, jsx_runtime_1.jsx)("span", { style: { color: t.Text, fontWeight: '500' }, children: e.lastName }) }, k)),
        'statusClass': (e, k, t, s) => ((0, jsx_runtime_1.jsx)("td", { style: { ...s }, children: (0, jsx_runtime_1.jsx)("span", { style: {
                    display: 'inline-block',
                    padding: '4px 8px',
                    borderRadius: 4,
                    color: (() => {
                        switch (e.statusClass) {
                            case 'A': return t.Text;
                            case 'T': return t.Text;
                            case 'L': return t.Text;
                            case 'P': return t.Text;
                        }
                    })(),
                    background: (() => {
                        switch (e.statusClass) {
                            case 'A': return t.Secondary + '33';
                            case 'T': return t.Red + '33';
                            case 'L': return t.Warning + '33';
                            case 'P': return t.CardBorder + '66';
                        }
                    })()
                }, children: Columns['statusClass'].value(e) }) }, k)),
        'hireDate': (e, k, t, s) => ((0, jsx_runtime_1.jsx)("td", { style: { ...s }, children: (0, jsx_runtime_1.jsx)("span", { style: { color: t.Text }, children: e.hireDate }) }, k))
    };
    return ((0, jsx_runtime_1.jsxs)("div", { style: { flex: 1, overflow: 'auto', padding: '0 16px 16px 16px' }, children: [(0, jsx_runtime_1.jsxs)("table", { onDragOver: (e) => e.preventDefault(), style: {
                    fontSize: 16,
                    borderSpacing: 0,
                    color: THEME.Text,
                    minWidth: '100%',
                    height: 1 // Fix 100% height for cell content.
                }, children: [(0, jsx_runtime_1.jsx)("thead", { children: (0, jsx_runtime_1.jsxs)("tr", { style: {
                                position: 'sticky', top: 0,
                                backgroundColor: THEME.CardBackground
                            }, children: [(0, jsx_runtime_1.jsx)("th", { style: {
                                        padding: 0,
                                        width: 18,
                                        userSelect: 'none',
                                        borderBottomWidth: 3,
                                        borderBottomStyle: 'solid',
                                        borderBottomColor: THEME.CardBorder
                                    }, children: "\u00A0" }), columns.map((field, index) => (field in Columns) &&
                                    (0, jsx_runtime_1.jsxs)("th", { draggable: true, onDragOver: (e) => {
                                            e.preventDefault();
                                            if (index == dragging.index)
                                                return;
                                            let rect = e.currentTarget.getBoundingClientRect();
                                            let x = e.clientX - rect.left;
                                            let i = null;
                                            if (x < rect.width / 2) {
                                                i = index;
                                            }
                                            else if (x > rect.width / 2) {
                                                i = index + 1;
                                            }
                                            if (i != null && i != dragging.index) {
                                                i = i < dragging.index ? i : i - 1;
                                                let c = [...columns];
                                                let r = c.splice(dragging.index, 1);
                                                c.splice(i, 0, ...r);
                                                setDragging({ ...dragging, index: i });
                                                setColumns(c);
                                                props.onUpdateColumns?.(c);
                                            }
                                        }, onDragStart: () => setDragging({ index }), onDragEnd: () => setDragging({}), onClick: () => props.onUpdateSort?.(field), style: {
                                            fontWeight: '500',
                                            textAlign: 'left',
                                            userSelect: 'none',
                                            cursor: 'pointer',
                                            minWidth: 120,
                                            padding: '8px 4px',
                                            borderBottomWidth: 3,
                                            borderBottomStyle: 'solid',
                                            borderBottomColor: THEME.CardBorder,
                                            whiteSpace: 'nowrap',
                                        }, children: [Columns[field]?.label, (() => {
                                                const sortIndex = props.sorts?.findIndex((sort) => sort.field == field);
                                                if (sortIndex == null || sortIndex < 0) {
                                                    return null;
                                                }
                                                const selectedSort = props.sorts[sortIndex];
                                                return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { size: 14, icon: selectedSort.direction == 'asc'
                                                                ? Theme_1.ICONS.Regular.ChevronUp
                                                                : Theme_1.ICONS.Regular.ChevronDown, style: {
                                                                color: THEME.Text,
                                                                marginLeft: 4,
                                                                marginBottom: selectedSort.direction == 'asc' ? -2 : 0
                                                            } }), (0, jsx_runtime_1.jsx)("span", { style: {
                                                                marginLeft: 4,
                                                                fontSize: 12,
                                                                fontWeight: '700',
                                                                color: THEME.Text
                                                            }, children: sortIndex + 1 })] }));
                                            })()] }, 'employees-header-' + index))] }) }), (0, jsx_runtime_1.jsxs)("tbody", { children: [props.employees.map((e) => (0, jsx_runtime_1.jsxs)("tr", { role: "link", tabIndex: 0, className: e.statusClass == 'P' ? 'prehire' : 'employee', onClick: () => {
                                    if (e.id == props.userEmployeeId) {
                                        props.onClickSelf?.(e.fullName);
                                    }
                                    else if (e.statusClass != 'P') {
                                        props.onEmployeeSelected?.(e.id);
                                        props.navigation.navigate('CompanyEmployeeDetail', { employeeId: e.id });
                                    }
                                }, onKeyDown: (e) => {
                                    if (e.key == 'Enter') {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        e.target.click();
                                    }
                                }, style: {
                                    borderBottomWidth: 1,
                                    borderBottomStyle: 'solid',
                                    borderBottomColor: THEME.CardBorder
                                }, children: [(0, jsx_runtime_1.jsx)("td", { style: {
                                            padding: 6,
                                            borderBottomWidth: 1,
                                            borderBottomStyle: 'solid',
                                            borderBottomColor: THEME.CardBorder,
                                            textAlign: 'center'
                                        }, children: (0, jsx_runtime_1.jsx)("div", { style: {
                                                height: '100%',
                                                width: 6,
                                                background: (() => {
                                                    switch (e.statusClass) {
                                                        case 'A': return THEME.Secondary + '66';
                                                        case 'T': return THEME.Red + '66';
                                                        case 'L': return THEME.Warning + '66';
                                                        case 'P': return THEME.CardBorder + 'aa';
                                                    }
                                                })()
                                            }, children: "\u00A0" }) }), columns.map((c, i) => {
                                        if (!(c in Columns))
                                            return;
                                        let key = 'employees-row-' + e.id + 'column-' + c;
                                        let cellStyle = {
                                            padding: '12px 10px',
                                            borderBottomWidth: 1,
                                            borderBottomStyle: 'solid',
                                            borderBottomColor: THEME.CardBorder,
                                        };
                                        return (fieldRenderWeb[c]
                                            &&
                                                fieldRenderWeb[c](e, key, THEME, cellStyle)
                                            ||
                                                (0, jsx_runtime_1.jsx)("td", { 
                                                    // @ts-ignore
                                                    style: cellStyle, children: Columns[c]?.value
                                                        &&
                                                            Columns[c]?.value(e)
                                                        ||
                                                            e[c] }, key));
                                    })] }, 'employees-row-' + e.id)), !(props.employees?.length > 0) &&
                                (0, jsx_runtime_1.jsx)("tr", { children: (0, jsx_runtime_1.jsx)("td", { colSpan: 99, style: { padding: '12px 6px', opacity: 0.75 }, children: t("company:text.employeeNoMatch") }) })] })] }), (0, jsx_runtime_1.jsx)("div", { dangerouslySetInnerHTML: { __html: '<style> ' +
                        'table tr.prehire:hover td { cursor: default; } ' +
                        'table tr.employee:hover td { background: ' + THEME.Secondary + '11; cursor: pointer; } ' +
                        '</style>'
                } })] }));
};
const EmployeeTableMobile = (props) => {
    const THEME = (0, ThemeContext_1.useTheme)();
    const headersRef = react_1.default.useRef(null);
    const [columns, setColumns] = react_1.default.useState(props.columns);
    const [dragging, setDragging] = react_1.default.useState(null);
    const [gestureEnabled, setGestureEnabled] = react_1.default.useState(true);
    const columnWidth = 200;
    const statusWidth = 18;
    const tableMargin = 14;
    react_1.default.useEffect(() => {
        setColumns(props.columns);
    }, [props.columns]);
    const fieldRenderWeb = {
        'fullName': (e, k, t, vs, ts) => ((0, jsx_runtime_1.jsx)(react_native_2.View, { style: vs, children: (0, jsx_runtime_1.jsx)(react_native_2.Text, { style: { ...ts, fontWeight: '500' }, children: e.fullName }) }, k)),
        'firstName': (e, k, t, vs, ts) => ((0, jsx_runtime_1.jsx)(react_native_2.View, { style: vs, children: (0, jsx_runtime_1.jsx)(react_native_2.Text, { style: { ...ts, fontWeight: '500' }, children: e.firstName }) }, k)),
        'lastName': (e, k, t, vs, ts) => ((0, jsx_runtime_1.jsx)(react_native_2.View, { style: vs, children: (0, jsx_runtime_1.jsx)(react_native_2.Text, { style: { ...ts, fontWeight: '500' }, children: e.lastName }) }, k)),
        'statusClass': (e, k, t, vs, ts) => ((0, jsx_runtime_1.jsx)(react_native_2.View, { style: { ...vs, alignItems: 'flex-start' }, children: (0, jsx_runtime_1.jsx)(react_native_2.Text, { style: {
                    ...ts,
                    paddingVertical: 4,
                    paddingHorizontal: 8,
                    borderRadius: 4,
                    color: (() => {
                        switch (e.statusClass) {
                            case 'A': return t.Text;
                            case 'T': return t.Text;
                            case 'L': return t.Text;
                            case 'P': return t.Text;
                        }
                    })(),
                    backgroundColor: (() => {
                        switch (e.statusClass) {
                            case 'A': return t.Secondary + '33';
                            case 'T': return t.Red + '33';
                            case 'L': return t.Warning + '33';
                            case 'P': return t.CardBorder + '66';
                        }
                    })()
                }, children: Columns['statusClass'].value(e) }) }, k)),
        'hireDate': (e, k, t, vs, ts) => ((0, jsx_runtime_1.jsx)(react_native_2.View, { style: vs, children: (0, jsx_runtime_1.jsx)(react_native_2.Text, { style: ts, children: e.hireDate }) }, k))
    };
    const pan = react_native_gesture_handler_1.Gesture.Pan()
        .enabled(gestureEnabled)
        .activateAfterLongPress(200)
        .onStart((event) => {
        headersRef.current?.measure((x, y, w, h, px, py) => {
            if ((event.absoluteY > py) && (event.absoluteY < py + h)) {
                let adjustedX = Math.abs(px - tableMargin) + (event.absoluteX - statusWidth);
                let index = Math.floor(adjustedX / columnWidth);
                let innerX = adjustedX - (index * columnWidth);
                setDragging({ index, startIndex: index, innerX });
            }
            else {
                setGestureEnabled(false);
                setDragging(null);
            }
        });
    })
        .onUpdate((e) => {
        if (dragging) {
            let adjustedX = (e.translationX + dragging.innerX);
            let indexAdjust = (adjustedX < 0) ? Math.floor(adjustedX / columnWidth) : Math.trunc(adjustedX / columnWidth);
            let i = dragging.startIndex + indexAdjust;
            if (i != null && i != dragging.index) {
                let c = [...columns];
                let r = c.splice(dragging.index, 1);
                c.splice(i, 0, ...r);
                setDragging({ ...dragging, index: i });
                setColumns(c);
                props.onUpdateColumns?.(c);
            }
        }
    })
        .onEnd((e) => {
        setDragging(null);
    })
        .onFinalize(() => setGestureEnabled(true))
        .runOnJS(true);
    return ((0, jsx_runtime_1.jsx)(react_native_gesture_handler_1.GestureHandlerRootView, { children: (0, jsx_runtime_1.jsx)(react_native_gesture_handler_1.GestureDetector, { gesture: pan, children: (0, jsx_runtime_1.jsxs)(react_native_2.ScrollView, { scrollEnabled: dragging == null, horizontal: true, nestedScrollEnabled: true, contentContainerStyle: { flexDirection: 'column' }, style: { flex: 1, marginHorizontal: tableMargin }, children: [(0, jsx_runtime_1.jsxs)(react_native_2.View, { ref: headersRef, style: {
                            backgroundColor: THEME.CardBackground,
                            flexDirection: 'row',
                            alignItems: 'center'
                        }, children: [(0, jsx_runtime_1.jsx)(react_native_2.View, { style: {
                                    padding: 0,
                                    width: statusWidth,
                                    alignSelf: 'stretch',
                                    borderBottomWidth: 3,
                                    borderBottomColor: THEME.CardBorder,
                                } }), columns.map((field, index) => (field in Columns) &&
                                (0, jsx_runtime_1.jsxs)(react_native_2.Pressable, { onPress: () => props.onUpdateSort?.(field), style: {
                                        width: columnWidth,
                                        alignSelf: 'stretch',
                                        paddingVertical: 8,
                                        paddingHorizontal: 4,
                                        backgroundColor: (dragging?.index == index ? THEME.Secondary + '33' : null),
                                        borderBottomWidth: 3,
                                        borderBottomColor: THEME.CardBorder,
                                        flexDirection: 'row',
                                        alignItems: 'center'
                                    }, children: [(0, jsx_runtime_1.jsx)(react_native_2.Text, { style: { fontSize: 16, fontWeight: '500' }, children: Columns[field]?.label }), (() => {
                                            const sortIndex = props.sorts?.findIndex((sort) => sort.field == field) ?? -1;
                                            if (sortIndex < 0) {
                                                return null;
                                            }
                                            const selectedSort = props.sorts[sortIndex];
                                            return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { size: 14, icon: selectedSort.direction == 'asc'
                                                            ? Theme_1.ICONS.Regular.ChevronUp
                                                            : Theme_1.ICONS.Regular.ChevronDown, style: {
                                                            color: THEME.Text,
                                                            marginLeft: 4,
                                                            marginBottom: selectedSort.direction == 'asc'
                                                                ? -2
                                                                : 0
                                                        } }), (0, jsx_runtime_1.jsx)(react_native_2.Text, { style: {
                                                            marginLeft: 4,
                                                            fontSize: 12,
                                                            fontWeight: '700',
                                                            color: THEME.Text
                                                        }, children: sortIndex + 1 })] }));
                                        })()] }, 'employees-header-' + index))] }), (0, jsx_runtime_1.jsx)(react_native_2.VirtualizedList, { initialNumToRender: 16, data: props.employees, getItemCount: (data) => data.length, getItem: (data, index) => data[index], scrollEnabled: true, showsVerticalScrollIndicator: true, style: { flex: 1 }, renderItem: ({ item: e }) => (0, jsx_runtime_1.jsxs)(react_native_2.Pressable, { onPress: () => {
                                if (e.id == props.userEmployeeId) {
                                    props.onClickSelf?.(e.fullName);
                                }
                                else if (e.statusClass != 'P') {
                                    props.onEmployeeSelected?.(e.id);
                                    props.navigation.navigate('CompanyEmployeeDetail', { employeeId: e.id });
                                }
                            }, style: {
                                borderBottomWidth: 1,
                                borderBottomColor: THEME.CardBorder,
                                cursor: 'pointer',
                                flexDirection: 'row',
                                alignItems: 'center'
                            }, children: [(0, jsx_runtime_1.jsx)(react_native_2.View, { style: {
                                        padding: 4,
                                        alignSelf: 'stretch'
                                    }, children: (0, jsx_runtime_1.jsx)(react_native_2.View, { style: {
                                            flex: 1,
                                            width: 6,
                                            backgroundColor: (() => {
                                                switch (e.statusClass) {
                                                    case 'A': return THEME.Secondary + '66';
                                                    case 'T': return THEME.Red + '66';
                                                    case 'L': return THEME.Warning + '66';
                                                    case 'P': return THEME.CardBorder + 'aa';
                                                }
                                            })()
                                        } }) }), columns.map((c, i) => {
                                    if (!(c in Columns))
                                        return;
                                    let key = 'employees-row-' + e.id + 'column-' + c;
                                    let viewStyle = {
                                        width: columnWidth,
                                        paddingVertical: 12,
                                        paddingHorizontal: 10,
                                        paddingLeft: 14
                                    };
                                    let textStyle = {
                                        color: THEME.Text,
                                        fontSize: 16
                                    };
                                    return (fieldRenderWeb[c]
                                        &&
                                            fieldRenderWeb[c](e, key, THEME, viewStyle, textStyle)
                                        ||
                                            (0, jsx_runtime_1.jsx)(react_native_2.View, { style: viewStyle, children: (0, jsx_runtime_1.jsx)(react_native_2.Text, { style: textStyle, children: Columns[c]?.value
                                                        &&
                                                            Columns[c]?.value(e)
                                                        ||
                                                            e[c] }) }, key));
                                })] }, 'employees-row-' + e.id) })] }) }) }));
};
const EmployeeCardsMobile = (props) => {
    const THEME = (0, ThemeContext_1.useTheme)();
    const detailColumns = props.columns.filter((c) => !['fullName', 'lastName', 'firstName', 'statusClass', 'jobTitle'].includes(c));
    const fieldRenderMobile = {
        'hireDate': (e, k, t) => ((0, jsx_runtime_1.jsx)(react_native_2.Text, { style: { color: t.Text, fontSize: 12 }, children: e.hireDate }))
    };
    return ((0, jsx_runtime_1.jsx)(react_native_2.View, { style: { flex: 1, gap: 16 }, children: (0, jsx_runtime_1.jsx)(react_native_2.VirtualizedList, { initialNumToRender: 8, data: props.employees, getItemCount: (data) => data.length, getItem: (data, index) => data[index], scrollEnabled: true, showsVerticalScrollIndicator: true, style: { flex: 1, padding: 12, paddingTop: 0 }, renderItem: ({ item }) => (0, jsx_runtime_1.jsxs)(react_native_2.Pressable, { onPress: () => {
                    if (item.id == props.userEmployeeId) {
                        props.onClickSelf?.(item.fullName);
                    }
                    else if (item.statusClass != 'P') {
                        props.onEmployeeSelected?.(item.id);
                        props.navigation.navigate('CompanyEmployeeDetail', { employeeId: item.id });
                    }
                }, style: {
                    backgroundColor: THEME.CardBackground,
                    borderColor: THEME.CardBorder,
                    borderWidth: 1,
                    borderBottomWidth: 2,
                    borderRadius: 4,
                    marginBottom: 12
                }, children: [(0, jsx_runtime_1.jsxs)(react_native_2.View, { style: {
                            gap: 4, padding: 8
                        }, children: [(0, jsx_runtime_1.jsxs)(react_native_2.View, { style: { flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }, children: [(0, jsx_runtime_1.jsx)(react_native_2.Text, { numberOfLines: 1, style: { color: THEME.Text, fontSize: 16, fontWeight: '500' }, children: item.fullName }), (0, jsx_runtime_1.jsx)(react_native_2.View, { style: {
                                            paddingVertical: 4,
                                            paddingHorizontal: 8,
                                            borderRadius: 4,
                                            backgroundColor: (() => {
                                                switch (item.statusClass) {
                                                    case 'A': return THEME.Secondary + '33';
                                                    case 'T': return THEME.Red + '33';
                                                    case 'L': return THEME.Butter + '88';
                                                    case 'P': return THEME.CardBorder + 'aa';
                                                }
                                            })()
                                        }, children: (0, jsx_runtime_1.jsx)(react_native_2.Text, { style: {
                                                fontSize: 14,
                                                color: (() => {
                                                    switch (item.statusClass) {
                                                        case 'A': return THEME.Text;
                                                        case 'T': return THEME.Text;
                                                        case 'L': return THEME.Text;
                                                        case 'P': return THEME.Text;
                                                    }
                                                })(),
                                            }, children: (() => {
                                                switch (item.statusClass) {
                                                    case 'A': return 'Active';
                                                    case 'T': return 'Terminated';
                                                    case 'L': return 'On Leave';
                                                    case 'P': return 'New Hire';
                                                }
                                            })() }) })] }), (0, jsx_runtime_1.jsxs)(react_native_2.View, { style: { flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }, children: [(0, jsx_runtime_1.jsx)(react_native_2.Text, { numberOfLines: 1, style: { color: THEME.Text, fontSize: 14 }, children: item.jobTitle }), (0, jsx_runtime_1.jsx)(react_native_2.Text, { style: { color: THEME.Text, fontSize: 14, opacity: 0.75 }, children: item.id })] })] }), detailColumns.length > 0 &&
                        (0, jsx_runtime_1.jsx)(react_native_2.View, { style: { gap: 4, padding: 8, backgroundColor: THEME.OffWhiteGray, }, children: detailColumns.map((c) => {
                                let key = 'employees-row-' + item.id + 'column-' + c;
                                return ((0, jsx_runtime_1.jsxs)(react_native_2.View, { style: { flexDirection: 'row', alignItems: 'center', gap: 8 }, children: [(0, jsx_runtime_1.jsx)(react_native_2.Text, { numberOfLines: 1, style: { color: THEME.Text, fontSize: 12, opacity: 0.75 }, children: Columns[c]?.label }), (0, jsx_runtime_1.jsx)(react_native_2.Text, { style: { color: THEME.Text, fontSize: 12, opacity: 0.75 }, children: "\u2013" }), fieldRenderMobile[c]
                                            &&
                                                fieldRenderMobile[c](item, key, THEME)
                                            ||
                                                (0, jsx_runtime_1.jsx)(react_native_2.Text, { numberOfLines: 1, style: { color: THEME.Text, fontSize: 12 }, children: Columns[c]?.value
                                                        &&
                                                            Columns[c]?.value(item)
                                                        ||
                                                            item[c] })] }, key));
                            }) })] }, 'employees-card-' + item.id) }) }));
};
const ModalColumns = (props) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const THEME = (0, ThemeContext_1.useTheme)();
    const STYLES = (0, Theme_1.useGlobalStyles)();
    const { columns } = (0, ResponsiveContext_1.useResponsiveContext)();
    const onPressColumn = (field) => {
        if (props.columns.includes(field)) {
            props.onUpdateColumns(props.columns.filter(i => i != field));
        }
        else {
            if (Columns[field].addFirstColumn) {
                props.onUpdateColumns([field, ...props.columns]);
            }
            else {
                props.onUpdateColumns([...props.columns, field]);
            }
        }
    };
    return ((0, jsx_runtime_1.jsxs)(react_native_2.View, { style: {
            // @ts-ignore
            gap: 8, userSelect: 'none', cursor: 'auto',
            minHeight: (columns == 1 ? null : 400),
            minWidth: (columns == 1 ? '100%' : 600),
            maxWidth: (columns == 1 ? '100%' : 600),
            paddingBottom: (columns == 1 ? 16 : 0),
        }, children: [(0, jsx_runtime_1.jsxs)(react_native_2.View, { style: { flexDirection: 'row', alignItems: 'center', gap: 8 }, children: [(0, jsx_runtime_1.jsx)(react_native_2.Text, { style: { flex: 1, color: THEME.Text, fontSize: 20, fontWeight: '500' }, children: t('company:labels.columns') }), (0, jsx_runtime_1.jsx)(Button_1.default, { type: "solid", color: THEME.Primary + '22', onPress: () => {
                            props.onResetColumns({});
                            props.onClose();
                        }, children: (0, jsx_runtime_1.jsx)(react_native_2.View, { style: { marginHorizontal: 4 }, children: (0, jsx_runtime_1.jsx)(react_native_2.Text, { style: { color: THEME.Text, fontSize: 16 }, children: t("company:labels.reset") }) }) }), (0, jsx_runtime_1.jsx)(Button_1.default, { type: "solid", color: THEME.Secondary, onPress: () => props.onClose(), children: (0, jsx_runtime_1.jsxs)(react_native_2.View, { style: { marginHorizontal: 4, flexDirection: 'row', alignItems: 'center', gap: 4 }, children: [(0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: Theme_1.ICONS.Regular.Check, size: 16, style: { color: THEME.White } }), (0, jsx_runtime_1.jsx)(react_native_2.Text, { style: { color: THEME.White, fontSize: 16, fontWeight: '500' }, children: t('company:labels.apply') })] }) })] }), (0, jsx_runtime_1.jsx)(react_native_2.View, { style: {
                    flex: 1, padding: 8, gap: 12, overflow: 'hidden',
                    borderColor: THEME.CardBorder, borderWidth: 1, borderRadius: 4,
                }, children: Object.values(SortedColumnKeysGrouped).map((group, groupIndex) => (0, jsx_runtime_1.jsxs)(react_native_2.View, { style: { gap: 12 }, children: [(0, jsx_runtime_1.jsx)(react_native_2.View, { style: { flexDirection: 'row', flexWrap: 'wrap', gap: 4 }, children: group.map((c) => (0, jsx_runtime_1.jsxs)(react_native_2.Pressable, { onPress: () => onPressColumn(c), style: {
                                    flexDirection: 'row', alignItems: 'center', gap: 8,
                                    paddingVertical: 8, paddingHorizontal: 16,
                                    width: (columns == 1 ? 148 : '32%')
                                }, children: [(0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: props.columns.includes(c) ? Theme_1.ICONS.Solid.SquareCheck : Theme_1.ICONS.Regular.Square, size: 18, style: { color: THEME.Text } }), (0, jsx_runtime_1.jsx)(react_native_2.Text, { style: { color: THEME.Text }, children: Columns[c]?.label })] }, 'column-select-' + c)) }), groupIndex < (Object.keys(SortedColumnKeysGrouped).length - 1) &&
                            (0, jsx_runtime_1.jsx)(react_native_2.View, { style: { borderBottomColor: THEME.CardBorder, borderBottomWidth: 1, marginHorizontal: 8 } })] }, 'column-group-' + groupIndex)) })] }));
};
const ModalFilters = (props) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const THEME = (0, ThemeContext_1.useTheme)();
    const { columns } = (0, ResponsiveContext_1.useResponsiveContext)();
    const [filterEdit, setFilterEdit] = react_1.default.useState('statusClass');
    const onPressFilterShowAll = () => {
        let next = { ...props.filters };
        delete next[filterEdit];
        props.onUpdateFilters(next);
    };
    const onPressFilterValue = (value) => {
        let next = { ...props.filters };
        if (filterEdit in props.filters) {
            if (props.filters[filterEdit].includes(value)) {
                next[filterEdit] = props.filters[filterEdit].filter((i) => i != value);
                if (next[filterEdit].length == 0) {
                    delete next[filterEdit];
                }
            }
            else {
                next[filterEdit] = [...props.filters[filterEdit], value];
            }
        }
        else {
            next[filterEdit] = [value];
        }
        props.onUpdateFilters(next);
    };
    return ((0, jsx_runtime_1.jsxs)(react_native_2.View, { style: {
            // @ts-ignore
            gap: 8, userSelect: 'none', cursor: 'auto',
            minHeight: (columns == 1 ? null : 400),
            minWidth: (columns == 1 ? '100%' : 600),
            maxWidth: (columns == 1 ? '100%' : 600),
            paddingBottom: (columns == 1 ? 16 : 0),
        }, children: [(0, jsx_runtime_1.jsxs)(react_native_2.View, { style: { flexDirection: 'row', alignItems: 'center', gap: 8 }, children: [(0, jsx_runtime_1.jsx)(react_native_2.Text, { style: { flex: 1, color: THEME.Text, fontSize: 20, fontWeight: '500' }, children: t('company:labels.filters') }), (0, jsx_runtime_1.jsx)(Button_1.default, { type: "solid", color: THEME.Primary + '22', onPress: () => {
                            props.onResetFilters({});
                            props.onClose();
                        }, children: (0, jsx_runtime_1.jsx)(react_native_2.View, { style: { marginHorizontal: 4 }, children: (0, jsx_runtime_1.jsx)(react_native_2.Text, { style: { color: THEME.Text, fontSize: 16 }, children: t("company:labels.reset") }) }) }), (0, jsx_runtime_1.jsx)(Button_1.default, { type: "solid", color: THEME.Secondary, onPress: () => props.onClose(), children: (0, jsx_runtime_1.jsxs)(react_native_2.View, { style: { marginHorizontal: 4, flexDirection: 'row', alignItems: 'center', gap: 4 }, children: [(0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: Theme_1.ICONS.Regular.Check, size: 16, style: { color: THEME.White } }), (0, jsx_runtime_1.jsx)(react_native_2.Text, { style: { color: THEME.White, fontSize: 16, fontWeight: '500' }, children: t('company:labels.apply') })] }) })] }), (columns == 1 && filterEdit) &&
                (0, jsx_runtime_1.jsxs)(react_native_2.Pressable, { onPress: () => setFilterEdit(null), style: {
                        paddingVertical: 12, paddingHorizontal: 24,
                        borderColor: THEME.CardBorder, borderWidth: 1, borderRadius: 4,
                        flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between'
                    }, children: [(0, jsx_runtime_1.jsx)(react_native_2.Text, { style: { color: THEME.Text, fontWeight: '500' }, children: Columns[filterEdit].label }), (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: Theme_1.ICONS.Solid.CaretDown, size: 20, style: { color: THEME.Text } })] }), (0, jsx_runtime_1.jsxs)(react_native_2.View, { style: { flex: 1, flexDirection: 'row', gap: 12 }, children: [(columns > 1 || !filterEdit) &&
                        (0, jsx_runtime_1.jsx)(react_native_2.View, { style: {
                                flex: 1, padding: 8, gap: 4,
                                borderColor: THEME.CardBorder, borderWidth: 1, borderRadius: 4,
                            }, children: SortedColumnKeys.map((c) => Columns[c].filterable &&
                                (0, jsx_runtime_1.jsxs)(react_native_2.Pressable, { onPress: () => setFilterEdit(c), style: {
                                        flexDirection: 'row', alignItems: 'center', gap: 8,
                                        paddingVertical: 8, paddingHorizontal: 16, borderRadius: 4,
                                        backgroundColor: filterEdit == c ? THEME.Secondary + 22 : null
                                    }, children: [(0, jsx_runtime_1.jsx)(react_native_2.Text, { numberOfLines: 1, style: { color: THEME.Text, fontWeight: '500' }, children: Columns[c].label }), (c in props.filters)
                                            &&
                                                (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(react_native_2.Text, { style: { color: THEME.Text }, children: "\u2013" }), (0, jsx_runtime_1.jsxs)(react_native_2.Text, { numberOfLines: 1, style: { color: THEME.Text }, children: [props.filters[c].length, " selected"] })] })] }, 'filter-edit-' + c)) }), (columns > 1 || filterEdit) &&
                        (0, jsx_runtime_1.jsx)(react_native_2.View, { style: {
                                flex: 1, padding: 8, gap: 4,
                                borderColor: THEME.CardBorder, borderWidth: 1, borderRadius: 4,
                            }, children: filterEdit in props.filterValues &&
                                (0, jsx_runtime_1.jsxs)(react_native_2.ScrollView, { contentContainerStyle: { flex: 1 }, style: { flex: 1 }, showsVerticalScrollIndicator: true, children: [(0, jsx_runtime_1.jsxs)(react_native_2.Pressable, { onPress: () => onPressFilterShowAll(), style: {
                                                flexDirection: 'row', alignItems: 'center', gap: 8,
                                                paddingVertical: 8, paddingHorizontal: 16
                                            }, children: [(0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: filterEdit in props.filters ? Theme_1.ICONS.Regular.Square : Theme_1.ICONS.Solid.SquareCheck, size: 18, style: { color: THEME.Text } }), (0, jsx_runtime_1.jsx)(react_native_2.Text, { style: { color: THEME.Text, fontWeight: '500' }, children: t("company:labels.showAll") })] }), props.filterValues[filterEdit].map((value, index) => (0, jsx_runtime_1.jsxs)(react_native_2.Pressable, { onPress: () => onPressFilterValue(value), style: {
                                                flexDirection: 'row', alignItems: 'center', gap: 8,
                                                paddingVertical: 8, paddingHorizontal: 16
                                            }, children: [(0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: props.filters[filterEdit]?.includes(value) ? Theme_1.ICONS.Solid.SquareCheck : Theme_1.ICONS.Regular.Square, size: 18, style: { color: THEME.Text } }), (0, jsx_runtime_1.jsx)(react_native_2.Text, { style: { color: THEME.Text }, children: value })] }, 'filter-value-' + index))] }) })] })] }));
};
function CompanyEmployees(props) {
    const { t } = (0, react_i18next_1.useTranslation)();
    const THEME = (0, ThemeContext_1.useTheme)();
    const { size, columns: responsiveColumns } = (0, ResponsiveContext_1.useResponsiveContext)();
    const userContext = react_1.default.useContext(UserContext_1.UserContext);
    const adminContext = react_1.default.useContext(AdminContext_1.AdminContext);
    const clientId = userContext.client?.id;
    const employeeId = userContext.employee?.employeeId;
    const keyColumns = `${clientId}-${employeeId}-employees-columns`;
    const keyFilters = `${clientId}-${employeeId}-employees-filters`;
    const keySearch = `${clientId}-${employeeId}-employees-search`;
    const keySort = `${clientId}-${employeeId}-employees-sort`;
    const defaultColumns = ['fullName', 'jobTitle', 'locationText', 'departmentText', 'employeeTypeText'];
    const defaultSorts = [{
            field: 'fullName',
            direction: 'asc'
        }
    ];
    const defaultFilters = { 'statusClass': ['Active', 'On Leave', 'New Hire'] };
    const defaultSearch = '';
    const promise = react_1.default.useRef(null);
    const [status, setStatus] = react_1.default.useState('loading');
    const [data, setData] = react_1.default.useState([]);
    const [employees, setEmployees] = react_1.default.useState([]);
    const [columns, setColumns] = react_1.default.useState([]);
    const [sorts, setSorts] = react_1.default.useState(defaultSorts);
    const [hasCustomSort, setHasCustomSort] = react_1.default.useState(false);
    const [filters, setFilters] = react_1.default.useState(defaultFilters);
    const [search, setSearch] = react_1.default.useState(defaultSearch);
    const [modal, setModal] = react_1.default.useState(null);
    const [modalSelfName, setModalSelfName] = react_1.default.useState(null);
    const filterValues = react_1.default.useRef({ statusClass: ['Active', 'Terminated', 'On Leave'] });
    const refresh = react_1.default.useCallback(() => {
        promise.current?.cancel();
        setStatus('loading');
        promise.current = (0, cancelable_promise_1.cancelable)(userContext.getToken().then(async (token) => {
            let eTask = Employees_1.default.getEmployeeList(token, '', '');
            let pTask = Employees_1.default.getPrehireList(token, false);
            return {
                employees: await eTask,
                prehires: await pTask.catch(() => null)
            };
        })).then((response) => {
            setData([
                ...(response.employees ?? []),
                ...(response.prehires ?? []).filter((p) => !response.employees?.some(e => e.id == p.id))
            ]);
            setStatus('done');
        }).catch(e => {
            setStatus((e == 404) ? 'done' : 'error');
        });
    }, []);
    react_1.default.useEffect(() => {
        refresh();
        return () => promise.current?.cancel();
    }, []);
    react_1.default.useEffect(() => {
        async_storage_1.default.getItem(keyColumns).then((v) => {
            if (v == null) {
                setColumns(defaultColumns);
            }
            else {
                try {
                    setColumns(JSON.parse(v));
                }
                catch {
                    setColumns(defaultColumns);
                }
            }
        });
        async_storage_1.default.getItem(keyFilters).then((v) => {
            if (v == null) {
                setFilters(defaultFilters);
            }
            else {
                try {
                    setFilters(JSON.parse(v));
                }
                catch {
                    setFilters(defaultFilters);
                }
            }
        });
        async_storage_1.default.getItem(keySearch).then((v) => {
            if (v == null) {
                setSearch(defaultSearch);
            }
            else {
                try {
                    setSearch(v);
                }
                catch {
                    setSearch(defaultSearch);
                }
            }
        });
        async_storage_1.default.getItem(keySort).then((v) => {
            if (v == null) {
                setSorts(defaultSorts);
                setHasCustomSort(false);
                return;
            }
            try {
                const savedSorts = JSON.parse(v);
                if (Array.isArray(savedSorts) && savedSorts.length > 0) {
                    setSorts(savedSorts);
                    setHasCustomSort(true);
                }
                else {
                    setSorts(defaultSorts);
                    setHasCustomSort(false);
                }
            }
            catch {
                setSorts(defaultSorts);
                setHasCustomSort(false);
                async_storage_1.default.removeItem(keySort);
            }
        });
    }, []);
    react_1.default.useEffect(() => {
        let copy = [...data];
        if (filters) {
            for (let f in filters) {
                copy = copy.filter((e) => {
                    let value = e[f];
                    if (Columns[f]?.value) {
                        value = Columns[f]?.value(e);
                    }
                    return filters[f]?.includes(value);
                });
            }
        }
        if (search) {
            let s = search.toUpperCase();
            copy = copy.filter((e) => {
                let result = false;
                for (let c in Columns) {
                    let value = e[c];
                    if (Columns[c]?.value) {
                        value = Columns[c]?.value(e);
                    }
                    result = result || value?.toUpperCase()?.includes(s);
                }
                return result;
            });
        }
        if (sorts.length > 0) {
            copy.sort((a, b) => {
                for (const sort of sorts) {
                    const direction = sort.direction == 'asc' ? 1 : -1;
                    let aValue = a[sort.field];
                    let bValue = b[sort.field];
                    if (Columns[sort.field]?.sortValue) {
                        aValue = Columns[sort.field].sortValue(a);
                        bValue = Columns[sort.field].sortValue(b);
                    }
                    else if (Columns[sort.field]?.value) {
                        aValue = Columns[sort.field].value(a);
                        bValue = Columns[sort.field].value(b);
                    }
                    let comparison = 0;
                    if (aValue == null && bValue != null) {
                        comparison = -1;
                    }
                    else if (aValue != null && bValue == null) {
                        comparison = 1;
                    }
                    else if (typeof aValue == 'number' && typeof bValue == 'number') {
                        comparison = aValue - bValue;
                    }
                    else {
                        comparison = String(aValue ?? '').localeCompare(String(bValue ?? ''), undefined, { sensitivity: 'base' });
                    }
                    if (comparison != 0) {
                        return comparison * direction;
                    }
                }
                return 0;
            });
        }
        setEmployees(copy);
    }, [data, search, filters, sorts]);
    const updateColumns = (value) => {
        setColumns(value);
        async_storage_1.default.setItem(keyColumns, JSON.stringify(value));
    };
    const resetColumns = () => {
        setColumns(defaultColumns);
        async_storage_1.default.removeItem(keyColumns);
    };
    const updateSort = (field) => {
        let nextSorts;
        if (!hasCustomSort) {
            const defaultSort = sorts[0];
            if (field == 'fullName' && sorts.length == 1 && defaultSort?.field == 'fullName') {
                nextSorts = [{
                        field: 'fullName',
                        direction: defaultSort.direction == 'asc' ? 'desc' : 'asc'
                    }];
            }
            else {
                nextSorts = [{
                        field,
                        direction: 'asc'
                    }];
            }
        }
        else {
            const sortIndex = sorts.findIndex((sort) => sort.field == field);
            if (sortIndex == -1) {
                nextSorts = [
                    ...sorts,
                    {
                        field,
                        direction: 'asc'
                    }
                ];
            }
            else {
                nextSorts = sorts.map((sort, index) => {
                    if (index != sortIndex) {
                        return sort;
                    }
                    return {
                        ...sort,
                        direction: sort.direction == 'asc'
                            ? 'desc'
                            : 'asc'
                    };
                });
            }
        }
        setSorts(nextSorts);
        setHasCustomSort(true);
        async_storage_1.default.setItem(keySort, JSON.stringify(nextSorts));
    };
    const clearSort = () => {
        setSorts(defaultSorts);
        setHasCustomSort(false);
        async_storage_1.default.removeItem(keySort);
    };
    const updateFilters = (value) => {
        setFilters(value);
        async_storage_1.default.setItem(keyFilters, JSON.stringify(value));
    };
    const resetFilters = () => {
        setFilters(defaultFilters);
        setSearch('');
        async_storage_1.default.removeItem(keyFilters);
        async_storage_1.default.removeItem(keySearch);
    };
    const updateSearch = (s) => {
        setSearch(s);
        if (s && s != defaultSearch) {
            async_storage_1.default.setItem(keySearch, s);
        }
        else {
            async_storage_1.default.removeItem(keySearch);
        }
    };
    const collectFilterValues = () => {
        let values = {};
        for (let c in Columns) {
            if (Columns[c].filterValues) {
                values[c] = Columns[c].filterValues;
            }
            for (let d of data) {
                let value = d[c];
                if (Columns[c]?.value) {
                    value = Columns[c]?.value(d);
                }
                if (value?.length > 0) {
                    if (c in values) {
                        if (!values[c].includes(value)) {
                            values[c].push(value);
                        }
                    }
                    else {
                        values[c] = [value];
                    }
                }
            }
            values[c]?.sort();
        }
        return values;
    };
    const employeeSelected = (id) => {
        let menu = employees.reduce((all, item) => {
            if (item.id != userContext?.employee?.employeeId) {
                all.push({
                    id: item.id,
                    statusClass: item.statusClass,
                    fullName: item.fullName
                });
            }
            return all;
        }, []);
        adminContext.setEmployeeMenu(menu);
    };
    const portalEnabled = userContext?.adminExperience == 'both' || userContext?.adminExperience == 'elevate-edge';
    if (!portalEnabled) {
        props.navigation?.navigate('Company');
    }
    const isWebGrid = react_native_1.Platform.OS == 'web' && responsiveColumns > 1;
    const isTabletGrid = react_native_1.Platform.OS != 'web' && react_native_device_info_1.default.isTablet();
    const supportsLayeredSorting = isWebGrid || isTabletGrid;
    const DynamicEmployeeList = isWebGrid ? EmployeeTableWeb : isTabletGrid ? EmployeeTableMobile : EmployeeCardsMobile;
    return ((0, jsx_runtime_1.jsxs)(react_native_2.View, { style: {
            flex: 1,
            backgroundColor: THEME.CardBackground
        }, children: [(0, jsx_runtime_1.jsxs)(react_native_2.View, { style: { flex: 1 }, children: [(0, jsx_runtime_1.jsxs)(react_native_2.View, { style: {
                            padding: (responsiveColumns == 1 ? 12 : 16),
                            paddingLeft: (responsiveColumns == 1 ? 12 : 22),
                            paddingRight: (responsiveColumns == 1 ? 12 : 24),
                            flexDirection: 'row', alignItems: 'center',
                            gap: (responsiveColumns > 1 ? 36 : 12)
                        }, children: [(responsiveColumns > 1 && size != 'sm') &&
                                (0, jsx_runtime_1.jsxs)(react_native_2.View, { style: { flexDirection: 'row', alignItems: 'center', gap: 12 }, children: [(0, jsx_runtime_1.jsx)(react_native_2.Text, { style: { color: THEME.Text, fontSize: 20, fontWeight: '500' }, children: t('company:labels.employees') }), status == 'done' &&
                                            (0, jsx_runtime_1.jsx)(react_native_2.View, { style: {
                                                    flexDirection: 'row', alignItems: 'center', justifyContent: 'center', gap: 6,
                                                    backgroundColor: THEME.Slate, borderRadius: 4,
                                                    paddingHorizontal: 8, paddingVertical: 4, minWidth: 48
                                                }, children: (0, jsx_runtime_1.jsx)(react_native_2.Text, { style: { color: THEME.White, fontSize: 18, fontWeight: '500' }, children: employees.length }) })] }), (0, jsx_runtime_1.jsx)(react_native_2.View, { style: { flex: 1 }, children: (0, jsx_runtime_1.jsx)(react_native_paper_1.TextInput, { dense: true, disabled: status != 'done', mode: "outlined", placeholder: "Search", value: search ?? '', onChangeText: (value) => updateSearch(value), style: { height: 40 }, right: search &&
                                        (0, jsx_runtime_1.jsx)(react_native_paper_1.TextInput.Icon, { tabIndex: -1, icon: () => (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: Theme_1.ICONS.Regular.Xmark, color: THEME.Text, size: 20 }), onPress: () => updateSearch(defaultSearch) }) }) }), (0, jsx_runtime_1.jsxs)(react_native_2.View, { style: { flexDirection: 'row', alignItems: 'center', gap: (responsiveColumns == 1 ? 4 : 12) }, children: [(0, jsx_runtime_1.jsxs)(Button_1.default, { type: "borderless", color: THEME.Text, disabled: status != 'done', style: { opacity: status != 'done' ? 0.5 : 1 }, onPress: () => setModal('columns'), children: [(0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: Theme_1.ICONS.Regular.Columns, size: 18, style: { color: THEME.Text } }), responsiveColumns > 1 &&
                                                (0, jsx_runtime_1.jsx)(react_native_2.Text, { style: { color: THEME.Text, fontSize: 16, marginLeft: 6 }, children: t('company:labels.columns') })] }), (0, jsx_runtime_1.jsx)(Button_1.default, { type: "borderless", color: THEME.Text, disabled: status != 'done', style: { opacity: status != 'done' ? 0.5 : 1 }, onPress: () => {
                                            filterValues.current = collectFilterValues();
                                            setModal('filter');
                                        }, children: (0, jsx_runtime_1.jsxs)(react_native_2.View, { style: { marginHorizontal: 4, flexDirection: 'row', alignItems: 'center', gap: 6 }, children: [(Object.keys(filters).length == 0 || responsiveColumns == 1)
                                                    &&
                                                        (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: Theme_1.ICONS.Regular.Filter, size: 18, style: { color: THEME.Text } }), (Object.keys(filters).length > 0 && responsiveColumns > 1)
                                                    &&
                                                        (0, jsx_runtime_1.jsx)(react_native_2.Text, { style: {
                                                                backgroundColor: THEME.Salmon, borderRadius: 6,
                                                                paddingHorizontal: 6, paddingVertical: 3,
                                                                color: THEME.White, fontSize: 14, fontWeight: '700',
                                                            }, children: Object.keys(filters).length }), responsiveColumns > 1 &&
                                                    (0, jsx_runtime_1.jsx)(react_native_2.Text, { style: { color: THEME.Text, fontSize: 16 }, children: t('company:labels.filters') })] }) }), supportsLayeredSorting &&
                                        (0, jsx_runtime_1.jsxs)(Button_1.default, { type: "borderless", color: THEME.Text, disabled: status != 'done' || !hasCustomSort, style: {
                                                opacity: status != 'done' || !hasCustomSort
                                                    ? 0.5
                                                    : 1
                                            }, onPress: clearSort, children: [(0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: Theme_1.ICONS.Regular.Xmark, size: 18, style: { color: THEME.Text } }), (0, jsx_runtime_1.jsx)(react_native_2.Text, { style: {
                                                        color: THEME.Text,
                                                        fontSize: 16,
                                                        marginLeft: 6
                                                    }, children: t('company:labels.clearSort') })] }), userContext.permissions?.includes(ElevatePermissions_1.default.Hire) &&
                                        (0, jsx_runtime_1.jsx)(Button_1.default, { type: "solid", color: THEME.Secondary, onPress: () => props.navigation.navigate('AddEmployee'), children: (0, jsx_runtime_1.jsxs)(react_native_2.View, { style: { marginHorizontal: 4, flexDirection: 'row', alignItems: 'center', gap: 4 }, children: [(0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: Theme_1.ICONS.Regular.Plus, size: 18, style: { color: THEME.White } }), (0, jsx_runtime_1.jsx)(react_native_2.Text, { style: { color: THEME.White, fontSize: 16, fontWeight: '500' }, children: t("company:labels.hire") })] }) })] })] }), status == 'loading'
                        &&
                            (0, jsx_runtime_1.jsx)(react_native_2.View, { style: {
                                    position: 'absolute', top: 0, left: 0, right: 0, bottom: 0,
                                    flexDirection: 'row', alignItems: 'center', justifyContent: 'center'
                                }, children: (0, jsx_runtime_1.jsx)(react_native_2.ActivityIndicator, { color: THEME.Primary, size: react_native_1.Platform.OS == 'web' ? 64 : 'large' }) })
                        ||
                            (0, jsx_runtime_1.jsx)(DynamicEmployeeList, { employees: employees, columns: columns, sorts: sorts, navigation: props.navigation, onEmployeeSelected: (id) => employeeSelected(id), userEmployeeId: userContext.employee?.employeeId, onClickSelf: (name) => {
                                    setModal('self');
                                    setModalSelfName(name);
                                }, onUpdateSort: (field) => updateSort(field), onUpdateColumns: (value) => updateColumns(value) })] }), modal &&
                (0, jsx_runtime_1.jsxs)(PlatformModal_1.default, { isVisible: modal, onDismiss: () => setModal(null), children: [modal == 'columns' &&
                            (0, jsx_runtime_1.jsx)(ModalColumns, { columns: columns, onUpdateColumns: (c) => updateColumns(c), onResetColumns: () => resetColumns(), onClose: () => setModal(null) }), modal == 'filter' &&
                            (0, jsx_runtime_1.jsx)(ModalFilters, { filters: filters, filterValues: filterValues.current, onUpdateFilters: (f) => updateFilters(f), onResetFilters: () => resetFilters(), onClose: () => setModal(null) }), modal == 'self' &&
                            (0, jsx_runtime_1.jsxs)(react_native_2.View, { style: {
                                    width: (size == 'sm' ? null : 550),
                                    gap: 24,
                                    marginBottom: (react_native_1.Platform.OS != 'web' ? 12 : 0)
                                }, children: [(0, jsx_runtime_1.jsxs)(react_native_2.View, { style: { gap: 16 }, children: [(0, jsx_runtime_1.jsx)(react_native_2.Text, { style: { color: THEME.Text, fontSize: 20, fontWeight: '500' }, children: modalSelfName }), (0, jsx_runtime_1.jsxs)(react_native_2.Text, { style: { color: THEME.Text, fontSize: 16 }, children: ["To manage your ", (0, jsx_runtime_1.jsx)(react_native_2.Text, { style: { fontWeight: '500' }, children: "personal information" }), ": Navigate to the ", (0, jsx_runtime_1.jsx)(react_native_2.Text, { style: { fontWeight: '500' }, children: "Home" }), " tab."] }), (0, jsx_runtime_1.jsxs)(react_native_2.Text, { style: { color: THEME.Text, fontSize: 16 }, children: ["To manage your ", (0, jsx_runtime_1.jsx)(react_native_2.Text, { style: { fontWeight: '500' }, children: "payroll or job information" }), ": Contact your ", (0, jsx_runtime_1.jsx)(react_native_2.Text, { style: { fontWeight: '500' }, children: "payroll specialist" }), "."] })] }), (0, jsx_runtime_1.jsx)(Button_1.default, { text: "OK", onPress: () => setModal(null) })] })] })] }));
}
